import { render, staticRenderFns } from "./strategy-organize.vue?vue&type=template&id=0aa2d6f9&scoped=true&"
import script from "./strategy-organize.vue?vue&type=script&lang=js&"
export * from "./strategy-organize.vue?vue&type=script&lang=js&"
import style0 from "./strategy-organize.vue?vue&type=style&index=0&id=0aa2d6f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa2d6f9",
  null
  
)

export default component.exports